import { render, staticRenderFns } from "./AdjustmentReasons.vue?vue&type=template&id=5cfb59e3"
import script from "./AdjustmentReasons.vue?vue&type=script&lang=js"
export * from "./AdjustmentReasons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports